import {
  SET_CLIENT,
  LOG_OUT,
} from '../constants';

const initialState = {
  categoriesLoaded: false,
  categories: [],
}

const categories = ( state = initialState, action ) => {
  switch ( action.type ) {
    case LOG_OUT:
      return {
        ...initialState,
      };
    case SET_CLIENT:
      return {
        ...state,
        categoriesLoaded: true,
        categoriesData: action.data,
        categories: action.data.categories.map((category, categoryIndex) => ({
          label: category.name,
          labelWithCount: `${category.name} (${category.subcategories.length})`,
          value: categoryIndex,
          options: ([{
            label: 'All Subcategories',
            value: category.subcategories.map(organisation => organisation.name).join('|'),
            categoryIndex,
            parentCategory: category.name,
          }]).concat(category.subcategories.map(organisation => ({
            label: organisation.name,
            value: organisation.name,
            categoryIndex,
            parentCategory: category.name,
          }))),
        })),
      };
    default:
      return state;
  }
};

export default categories;
